<div class="footer-wrap">
  <div class="container">
    <div class="flex flex-wrap items-start justify-between">
      <div class="w-full md:w-4/12 mb-6 md:mb-0">
        <p-card styleClass="card-footer mb-3 widget1">
          <a routerLink="/">
            <img class="footer-logo mb-4" src="images/logo-white.png" alt="footer-logo" />
          </a>
          <p class="font-semibold mb-5">
            Experience Speed and Reliability with Cladded Glass Broadband
          </p>
        </p-card>
      </div>
      <div class="w-full md:w-4/12 mb-6 md:mb-0">
        <div class="widget2 lg:w-[216px] mx-auto">
          <h4 class="text-white" style="font-weight: 700; margin-bottom: 20px">
            Company
          </h4>
          <ul class="list-none m-0 p-0">
            @for (item of footerInfo?.menu; let i = $index; track item.title)
            {
            <li class="fs-20 mb-3">
              <a pRipple (click)="item.command()">
                <span>{{ item.label }}</span>
              </a>
            </li>
            }
          </ul>
        </div>
      </div>
      <div class="w-full md:w-4/12">
        <div class="widget3 w-[377.87px] ml-auto">
          <h3 class="title">Contact Us</h3>
          <ul class="space-y-4 nav">
            <li class="flex items-center">
              <span>
                <img [src]="footerInfo?.contact?.phone?.icon" alt="contact icon" />
              </span>
              <span class="ml-4">{{ footerInfo?.contact?.phone?.text }}</span>
            </li>
            <li class="flex items-center">
              <span>
                <img [src]="footerInfo?.contact?.email?.icon" alt="contact icon" />
              </span>
              <span class="ml-4">{{ footerInfo?.contact?.email?.text }}</span>
            </li>
            <li class="flex items-center">
              <span>
                <img [src]="footerInfo?.contact?.address?.icon" alt="contact icon" />
              </span>
              <span class="ml-4">{{
                footerInfo?.contact?.address?.text
                }}</span>
            </li>

          </ul>
          <div class="flex space-x-4 mt-5">
            @for (item of footerInfo?.social; let i = $index; track item.id) {
            <a [routerLink]="item.link" class="social-btn">
              <i [class]="item.icon"></i>
            </a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="copyright-wrap text-white">
  <div class="copy-right">
    <div class="container">
      <div class="flex justify-between items-center lg:flex-row flex-col space-y-3">
        <p><strong>© 2025 Cladded Glass.</strong> All rights reserved.</p>
        <div class="flex space-x-4">
          <a href="#">Terms & Condition</a>
          <a href="#">Privacy & Policy</a>
        </div>
      </div>
    </div>
  </div>

</div>
